// Librairies importés.
import { Component, Vue } from "vue-property-decorator";

// Services.
import CguApiService from "@/services/cgu/CguApiService";
import UtilisateurProducteurService from "@/services/utilisateurProducteur/UtilisateurProducteurService";

// Store.
import store from "@/store";

// Modèles.
import { ConditionsGeneralesUtilisation } from "@/models/ConditionsGeneralesUtilisation.model";

// Enums.
import { SecurityStoreMethods } from "@/store/security/SecurityStore";
import { MessageLevel } from "@/shared/enums/MessageLevel.enum";

import { CoreHelper } from "@/shared/helpers/CoreHelper";

/**
 * Composant qui affiche les CGU de l'application et permet de les signer.
 */
@Component
export default class SignerCguPopupComponent extends Vue {
    /**
     * Le service permettant d'accéder à l'API des CGU.
     */
    private conditionsGeneralesUtilisationService = new CguApiService();

    /**
     * Le service permettant d'accéder à l'API des utilisateurs producteurs.
     */
    private utilisateurProducteurService = new UtilisateurProducteurService();

    /**
     * Les conditions générales d'utilisation.
     */
    public conditionsGeneralesUtilisation: ConditionsGeneralesUtilisation =
        new ConditionsGeneralesUtilisation();

    /**
     * Définie si la pop-up de signature des CGU est ouverte/visible.
     */
    public isOpen: boolean = true;

    /**
     * Chargement des conditions générales d'utilisation.
     */
    public mounted() {
        this.conditionsGeneralesUtilisationService
            .getUniqueCgu()
            .then((response) => {
                this.conditionsGeneralesUtilisation = response.data.data;
            });
    }

    /**
     * Clean de la chaine
     */
    public sanitize(data: string) {
        return CoreHelper.Sanitize(data);
    }

    /**
     * Action de signer les CGU par l'utilisateur actuellement authentifié.
     */
    public signer() {
        this.utilisateurProducteurService.signerCgu().then((response) => {
            const cguSigned = !response.data.messages.some(
                (m) => m.messageLevel === MessageLevel.Error
            );
            if (cguSigned) {
                store.commit(SecurityStoreMethods.SET_USER_HAS_SIGNED_CGU);
            }
        });
    }
}
